import { IIdentificationConfig } from "@piceasoft/core";
import * as UIKit from "@piceasoft/picea-react-ui-kit"
import { OnlineIconName } from "@piceasoft/picea-react-ui-kit"
import { strings } from "../../../../../../localization/strings";
import { Stack, getTheme } from "@fluentui/react";

type TProps = {
    config?: IIdentificationConfig
}

export const SelectTargetDevicePreview: React.FC<TProps> = (props) => {
    const title = props.config?.targetDeviceSelection?.title ? props.config?.targetDeviceSelection?.title : strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.UI_FLOW.SELECT_TARGET.DEFAULT_TITLE;
    const information = props.config?.targetDeviceSelection?.information ? props.config?.targetDeviceSelection?.information : strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.UI_FLOW.SELECT_TARGET.DEFAULT_DESCRIPTION;

    const items = [
        {
            id: '0',
            icon: 'cellPhoneIcon' as OnlineIconName,
            text: strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.UI_FLOW.SELECT_TARGET.THIS_DEVICE
        },
        {
            id: '1',
            icon: 'qrCodeIcon' as OnlineIconName,
            text: strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.UI_FLOW.SELECT_TARGET.OTHER_DEVICE
        }
    ]
    
    return (
        <Stack style={{ backgroundColor: 'rgba(0, 0, 0, 0.4)' }} >
            <Stack.Item tokens={{ padding: 24 }}>
                <Stack style={{ backgroundColor: theme.palette.neutralLighter, boxShadow: theme.effects.elevation64 }} >
                    <Stack.Item>
                        <Stack verticalAlign="center" tokens={{ childrenGap: 4 }} styles={{ root: { padding: "4px 16px 4px 24px", backgroundColor: theme.palette.white } }}> 
                            <div style={{justifyItems: 'center'}}>
                                <div style={{minWidth: '375px', paddingBottom: '24px'}}>
                                    <UIKit.Text fontSize={24}>
                                        {title}
                                    </UIKit.Text>
                                    <UIKit.Text fontSize={14}>
                                        <div dangerouslySetInnerHTML={{ __html: information }}></div>
                                    </UIKit.Text>
                                    <UIKit.TroubleshootCategoryList items={items} />
                                </div>
                            </div>
                        </Stack>        
                    </Stack.Item>
                </Stack>
            </Stack.Item>
         </Stack>
    )
}
const theme = getTheme();